import { render } from "./TagConsentOverviewWidget.vue?vue&type=template&id=47ff5404&scoped=true"
import script from "./TagConsentOverviewWidget.vue?vue&type=script&lang=js"
export * from "./TagConsentOverviewWidget.vue?vue&type=script&lang=js"

import "./TagConsentOverviewWidget.vue?vue&type=style&index=0&id=47ff5404&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ff5404"]])

export default __exports__